export default "__VITE_ASSET__DeqUXFhF__"